<template>
  <div class="general-grid" ref="grid">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DdGrid",
  props:{
    cols: Number,
    rows: Number,
  },
  mounted(){
    this.setGridTemplate();
  },
  watch:{
    $props: {
      handler() {
        this.setGridTemplate();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    setGridTemplate(){
      if ( this.cols ) this.$refs.grid.style.gridTemplateColumns = `repeat(${ this.cols }, 1fr)`
      if ( this.rows ) this.$refs.grid.style.gridTemplateRows = `repeat(${ this.rows }, 1fr)`
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'sass:map';
@import "~@/_default.scss";

.general-grid {
  display: grid;
  grid-gap: $spacing-md;
  grid-template-columns: repeat(3, 1fr);
  padding-right: $spacing-lg;
  padding-bottom: $spacing-xxl;
  margin-right: 75px;
  width: 100%;
}

@media screen and (max-width: map.get($grid-breakpoints, md)) {
  .general-grid {
    display: flex;
    flex-direction: column;
    row-gap: $spacing-md;
  }
}
</style>
